import { render, staticRenderFns } from "./AppBars.vue?vue&type=template&id=70037230&scoped=true&"
import script from "./AppBars.vue?vue&type=script&lang=js&"
export * from "./AppBars.vue?vue&type=script&lang=js&"
import style0 from "./AppBars.vue?vue&type=style&index=0&id=70037230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70037230",
  null
  
)

export default component.exports